import { apiFetch, safeJson } from './api';
import type { UserStats } from '../types';
import { displayMapName } from '../pages/Stats/statsUtils';

type StatsSummaryPayload = {
  mvps: number;
  total_matches: number;
  wins: number;
  losses: number;
  draws?: number;
  win_rate: number;
  kd: number;
  avg_score: number;
};

type StatsChartsPayload = {
  by_map?: { map: string }[];
};

export async function fetchProfileStats(): Promise<Partial<UserStats>> {
  try {
    const [sumRes, chartsRes] = await Promise.all([
      apiFetch('/stats/me/summary'),
      apiFetch('/stats/me/charts'),
    ]);

    const stats: Partial<UserStats> = {};

    if (sumRes.ok) {
      const s = await safeJson<StatsSummaryPayload>(sumRes);
      if (s) {
        stats.totalMatches = s.total_matches;
        stats.mvps=s.mvps;
        stats.wins = s.wins;
        stats.losses = s.losses;
        stats.draws = s.draws;
        stats.winRate = Math.round(s.win_rate * 10) / 10;
        stats.kd = Math.round(s.kd * 100) / 100;
        stats.avgScore = Math.round(s.avg_score);
      }
    }

    if (chartsRes.ok) {
      const charts = await safeJson<StatsChartsPayload>(chartsRes);
      const topMap = charts?.by_map?.[0]?.map;
      if (topMap) {
        stats.bestMap = displayMapName(topMap);
      }
    }

    return stats;
  } catch {
    return {};
  }
}
